import { Tr } from '@chakra-ui/react';
import { useGenericContext } from 'components/contexts/useGenericContext';
import { ValuationForm } from 'components/forms';
import { Td, TdActions } from 'components/lib';
import { CustomTable, FormDrawer } from 'components/modules';
import { FormikProps } from 'formik';
import { getId, getResults, isResultsEmpty } from 'helpers';
import fp from 'lodash/fp';
import { nanoid } from 'nanoid';
import { useCallback, useRef } from 'react';
import {
  IValuationPayload,
  IValuationResource,
} from 'services/resources/deal-flow/valuation/types.d';

import {
  getCompanyName,
  getCreated,
  getDilution,
  getExchange,
  getNumber,
  getValuation,
  getValuationType,
  HEADERS,
} from '../helpers';

export const Page: React.FC = (): JSX.Element => {
  const {
    active,
    defaultPatch,
    defaultRestore,
    isDrawerOpen,
    onPrepareDelete,
    onPrepareDrawer,
    registry,
    state,
    toggleDrawer,
  } = useGenericContext<IValuationResource>();

  const ref = useRef<FormikProps<IValuationPayload>>(null);

  const prepareFormValues = useCallback(
    () => ({
      ...registry,
      company: fp.get(['company', 'id'])(registry),
      exchange: fp.get(['exchange', 'id'])(registry),
      valuation_type: fp.get(['valuation_type', 'id'])(registry),
    }),
    [registry],
  );

  const prepareOnSubmit = useCallback(() => {
    if (ref?.current) ref?.current?.submitForm();
  }, [ref]);

  return (
    <>
      <CustomTable
        isEmpty={isResultsEmpty(state)}
        headers={HEADERS}
        isLoading={state?.loading}
        mx={8}
      >
        {getResults(state)?.map((row: IValuationResource) => (
          <Tr key={nanoid()} position="relative">
            <Td>{getId(row)}</Td>
            <Td>{getCompanyName(row)}</Td>
            <Td isNumeric>{getValuation(row)}</Td>
            <Td isNumeric>{getNumber(row)}</Td>
            <Td isNumeric>{getDilution(row)}</Td>
            <Td>{getExchange(row)}</Td>
            <Td>{getValuationType(row)}</Td>
            <Td>{getCreated(row)}</Td>
            <TdActions
              isActive={active}
              onDelete={() => onPrepareDelete(row)}
              onRestore={() => defaultRestore(row, { is_active: true })}
              onUpdate={() => onPrepareDrawer(row)}
            />
          </Tr>
        ))}
      </CustomTable>

      <FormDrawer
        isOpen={isDrawerOpen}
        isDisabled={!!ref?.current?.isSubmitting || !!ref?.current?.isValid}
        isLoading={!!ref.current?.isSubmitting}
        onClose={toggleDrawer}
        onSubmit={prepareOnSubmit}
      >
        <ValuationForm
          initialValues={prepareFormValues()}
          onSubmit={defaultPatch}
          ref={ref}
        />
      </FormDrawer>
    </>
  );
};
